import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/admin/organizations/$organizationId/',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    name: (search.name as string) || undefined,
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/admin/organizations/$organizationId/members',
      params,
      search,
    })
  },
})
